export const DW_NS = "dopewars_v0";
export const DW_GRAPHQL_MODEL_NS = "dopewarsV0";
